import { default as LabelValueBase } from '../LabelValueVertical';
export default LabelValueBase;